import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./Components/App";
import {BrowserRouter} from 'react-router-dom';
// import 'react-toastify/dist/ReactToastify.css';


ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
